import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ConfigurationService } from '../../../../configuration/configuration.service';
import { ConfigurationModel } from '../../../../shared/models/configuration.model';
import { FormattingModule } from '../../../../shared/formatting/formatting.module';
import { DatePipe, DecimalPipe } from '@angular/common';
import { environment} from '../../../../../environments/environment';
import { MapLayersManager } from '../../../../shared/components/map-viewer/map-layers-manager';
import { LngLat } from 'maplibre-gl';
import { LocationTrackingPollerService } from '../../../../data/server-events/location-tracking-poller.service';
import { Subscription } from 'rxjs';
import { TracksDebugLayerService } from '../../../../shared/components/map-viewer/services/tracks-debug-layer.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-debug-box',
  imports: [MatIconButton, MatIcon, MatTooltip, FormattingModule, DatePipe, MatButton, DecimalPipe, MatProgressSpinner],
  templateUrl: './debug-box.component.html',
  styleUrl: './debug-box.component.scss',
})
export class DebugBoxComponent implements OnInit, OnDestroy {
  @Input() mapLayersManager: MapLayersManager;
  @Output() hide = new EventEmitter<boolean>();
  configuration: ConfigurationModel;

  utcTime: Date = new Date();
  unixTime: number;
  lineDataTime: number;
  pointDataTime: number;
  zoomLevel: number;
  center: LngLat;
  snapshot: number;
  environment = environment.name;

  loadingData = false;
  intervalId: NodeJS.Timeout;
  private unsubscribeZoom: (() => void) | null = null;
  private unsubscribeMove: (() => void) | null = null;
  private configSubscription: Subscription;
  private viewStateSubscription: Subscription;

  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly locationTrackingPoller: LocationTrackingPollerService,
    private readonly tracksDebugLayerService: TracksDebugLayerService
  ) {}

  ngOnInit() {
    this.configSubscription = this.configurationService.sharedConfigurationModel.subscribe(model => {
      if (model) {
        this.configuration = model;

        // Set initial values
        this.zoomLevel = this.mapLayersManager.getZoom();
        this.center = this.mapLayersManager.getMapCenter();

        // Subscribe and store unsubscribe functions
        this.unsubscribeZoom = this.mapLayersManager.onZoom(() => {
          this.zoomLevel = this.mapLayersManager.getZoom();
        });

        this.unsubscribeMove = this.mapLayersManager.onMove(() => {
          this.center = this.mapLayersManager.getMapCenter();
        });
      }
    });
    this.updateTime();
    this.intervalId = setInterval(() => this.updateTime(), 1000);
    this.viewStateSubscription = this.locationTrackingPoller.viewStateObservable.subscribe(viewStateObservable => {
      if (viewStateObservable) {
        this.snapshot = viewStateObservable.snapshot;
      }
    });
    this.refreshData();
  }

  ngOnDestroy() {
    this.configSubscription?.unsubscribe();
    this.viewStateSubscription?.unsubscribe();
    clearInterval(this.intervalId);
    this.unsubscribeZoom?.();
    this.unsubscribeMove?.();
    this.tracksDebugLayerService.clearSources();
  }

  private updateTime() {
    this.utcTime = new Date();
    this.unixTime = Math.floor(this.utcTime.getTime() / 1000);
  }

  refreshData() {
    this.loadingData = true;
    this.tracksDebugLayerService.updateLineSource().then(() => {
      this.loadingData = false;
      this.lineDataTime = Math.floor(new Date().getTime() / 1000);
    });

    this.tracksDebugLayerService.updatePointSource(
      this.center,
      this.zoomLevel,
    )
      .then(() => (this.pointDataTime = Math.floor(new Date().getTime() / 1000)));
  }

  closeBox() {
    this.hide.emit(true);
  }
}
